const isFullyScrolledIntoView = (elem) => {
  const docViewTop = $(window).scrollTop();
  const docViewBottom = docViewTop + $(window).height();

  const elemTop = $(elem).offset().top;
  const elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
};

const isPartiallyScrolledIntoView = (elem) => {
  const docViewTop = $(window).scrollTop();
  const docViewBottom = docViewTop + $(window).height();

  const elemTop = $(elem).offset().top;
  const elemBottom = elemTop + $(elem).height();

  const bottomInView = (elemBottom <= docViewBottom) && (elemBottom >= docViewTop);
  const topInView = (elemTop >= docViewTop) && (elemTop <= docViewBottom);

  return bottomInView || topInView;
}


const animations = {
  patientsText: false,
  patientsImage: false,
  physicianText: false,
  physicianImage: false,
  pharmaText: false,
  pharmaImage: false
};

const benefitTextAnimationSpeed = 1000;
const benefitTextAnimationMovement = 100;
const benefitTextAnimationInitialDelay = 1500;
const benefitTextAnimationBetweenDelay = 500;
const benefitImageAnimationSpeed = 1000;
const benefitImageAnimationDelay = 0;

jQuery(() => {
  //Landing CTA animation
  $('.landing-cta').velocity({
    properties: {
      opacity: [1, 0],
      bottom: '10%'
    },
    options: {
      duration: 1000,
      easing: 'swing',
      delay: 1000,
      mobileHA: true
    }
  });

  $(window).scroll(() => {
    // Animate patient benefit text
    if ((isPartiallyScrolledIntoView('.benefit-section.patient-benefit') === true) &&
                                            (animations.patientsText === false)) {
      animations.patientsText = true;
      $('.patient-benefit h2').velocity({
        properties: {
          translateY: [0, benefitTextAnimationMovement],
          opacity: [1, 0]
        },
        options: {
          duration: benefitTextAnimationSpeed,
          easing: 'swing',
          mobileHA: true,
          delay: benefitTextAnimationInitialDelay,
          begin: () => {
            $('.patient-benefit .benefit-description').children('p').each((index, el) => {
              $(el).velocity({
                properties: {
                  translateY: [0, benefitTextAnimationMovement],
                  opacity: [1, 0]
                },
                options: {
                  duration: benefitTextAnimationSpeed,
                  delay: benefitTextAnimationBetweenDelay * (index + 1),
                  easing: 'swing',
                  mobileHA: true
                }
              })
            })
          }
        }
      })
    }

    // Animate patient benefit image
    if ((isFullyScrolledIntoView('#pazienti-sad') === true) &&
                                            (animations.patientsImage === false)) {
      animations.patientsImage = true;
      $('img#pazienti-sad').velocity({
        properties: {
          opacity: [0, 1]
        },
        options: {
          duration: benefitImageAnimationSpeed,
          complete: () => {
            $('img#pazienti-happy').velocity({
              properties: { opacity: [1, 0] },
              options: {
                duration: benefitImageAnimationSpeed,
                begin: () => {
                  $('img#pazienti-happy').removeClass('hidden');
                  $('img#pazienti-happy').css('opacity', '0');
                }
              }
            })
          }
        }
      })
    }

    // Animate physician benefit text
    if ((isPartiallyScrolledIntoView('.benefit-section.physician-benefit') === true) &&
                                            (animations.physicianText === false)) {
      animations.physicianText = true;
      $('.physician-benefit h2').velocity({
        properties: {
          translateY: [0, benefitTextAnimationMovement],
          opacity: [1, 0]
        },
        options: {
          duration: benefitTextAnimationSpeed,
          easing: 'swing',
          mobileHA: true,
          delay: benefitTextAnimationInitialDelay,
          begin: () => {
            $('.physician-benefit .benefit-description').children('p').each((index, el) => {
              $(el).velocity({
                properties: {
                  translateY: [0, benefitTextAnimationMovement],
                  opacity: [1, 0]
                },
                options: {
                  duration: benefitTextAnimationSpeed,
                  delay: benefitTextAnimationBetweenDelay * (index + 1),
                  easing: 'swing',
                  mobileHA: true
                }
              })
            })
          }
        }
      })
    }

    // Animate patient benefit image
    if ((isFullyScrolledIntoView('#physician-simple') === true) &&
                                            (animations.physicianImage === false)) {
      animations.physicianImage = true;
      $('#physician-simple .hidden-image-container').children().each((index, el) => {
        if ($(el).data('animate') === true) {
          const angle = parseInt($(el).data('angle'));
          const translateX = 200 * Math.cos(angle / 180 * Math.PI);
          const translateY = -200 * Math.sin(angle /180 * Math.PI);

          $(el).velocity({
            properties: {
              translateX: [translateX, 0],
              translateY: [translateY, 0],
              opacity: [0, 1]
            },
            options: {
              duration: benefitImageAnimationSpeed * 2,
              delay: benefitImageAnimationDelay,
              complete: () => $(el).remove()
            }
          })
        }
      });

      $('#physician-coffee').velocity({
        properties: {
          translateX: [-80, 0],
          translateY: [-80, 0]
        },
        options: {
          duration: benefitImageAnimationSpeed * 2,
          delay: benefitImageAnimationDelay
        }
      });
    }

    // Animate pharma benefit text
    if ((isPartiallyScrolledIntoView('.benefit-section.pharma-benefit') === true) &&
                                            (animations.pharmaText === false)) {
      animations.pharmaText = true;
      $('.pharma-benefit h2').velocity({
        properties: {
          translateY: [0, benefitTextAnimationMovement],
          opacity: [1, 0]
        },
        options: {
          duration: benefitTextAnimationSpeed,
          easing: 'swing',
          mobileHA: true,
          delay: benefitTextAnimationInitialDelay,
          begin: () => {
            $('.pharma-benefit .benefit-description').children('p').each((index, el) => {
              $(el).velocity({
                properties: {
                  translateY: [0, benefitTextAnimationMovement],
                  opacity: [1, 0]
                },
                options: {
                  duration: benefitTextAnimationSpeed,
                  delay: benefitTextAnimationBetweenDelay * (index + 1),
                  easing: 'swing',
                  mobileHA: true
                }
              })
            })
          }
        }
      })
    }

    // Animate pharma benefit image
    if ((isFullyScrolledIntoView('#pharma-image') === true) &&
                                            (animations.pharmaImage === false)) {
      animations.pharmaImage = true;
      $('#pharma-image').velocity({
        properties: {
          opacity: [0, 1]
        },
        options: {
          duration: benefitImageAnimationSpeed,
          complete: () => {
            $('#super-pharma-image').velocity({
              properties: {
                opacity: [1, 0]
              },
              options: {
                duration: benefitImageAnimationSpeed,
                begin: () => {
                  $('#super-pharma-image').removeClass('hidden');
                  $('#super-pharma-image').css('opacity', '0');
                }
              }
            })
          }
        }
      })
    }
  });
})



// WEBPACK FOOTER //
// ./src/js/application.js